<template>
  <div class="container">
      <Carousel
        v-model="initialSlide"
        :items-to-show="2"
        :items-to-scroll="1"
        :wrap-around="true"
        :autoplay="4000"
        snap-align="start"
        :breakpoints="{
          1500: { itemsToShow: 7, snapAlign: 'center' },
          1200: { itemsToShow: 5, snapAlign: 'center' },
          1024: { itemsToShow: 3, snapAlign: 'center' },
        }"
        ref="carousel"
      >
        <Slide v-for="item in items" :key="item.index">
          <a :href="item.url" target="_blank"><img :src="item.src" :alt="item.alt" /></a>
        </Slide>
      <template #addons>
        <Navigation />
      </template>
    </Carousel>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Navigation } from 'vue3-carousel'

export default {
  name: 'CarouselComponent',
  components: { Carousel, Slide, Navigation },
  props: {
    items: Array
  },
  data() {
    return {
      initialSlide: undefined,
    };
  },
  mounted() {
    this.initialSlide = 0;
  },
}
</script>

<style lang="scss">
  .carousel {
    margin: 15px;
    width: calc(100% - 30px);

    .carousel {
      &__slide {
        padding: 0 20px;

        &:before {
          display: none;
        }

        img {
          transition: all 0.25s ease-in-out;
          max-width: 100%;
          opacity: 0.75;
          -webkit-filter: grayscale(
            100%
          ); /* Webkit Nightlies & Google Chrome Canary */
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden; /* Fix for transition flickering */
          filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale"); /* Firefox 10+, Firefox on Android */
          filter: grayscale(100%); /* IE Edge */
          filter: gray; /* IE8-9 */
          &:hover {
            backface-visibility: hidden;
            -webkit-filter: grayscale(0);
            -webkit-backface-visibility: hidden; /* Fix for transition flickering */
            filter: none; /* Applies to FF + IE */
          }
        }
      }

      &__prev,
      &__next {
        color: #000;
        font-size: 40px;
        height: 40px;
        opacity: .25;
        transition: opacity .2s ease-in-out;
        width: 40px;

        &:hover {
          opacity: .75;
        }
      }

      &__prev {
        left: -15px;
      }

      &__next {
        right: -15px;
      }
    }
  }
</style>
